// Backend-loaded feature flags. Keys MUST match the backend FeatureFlag enum
// values (see replyn-backend src/feature-flag/feature-flag.enum.ts). Flags ride
// along on the organization payload and default to off when absent.
export const FEATURE_FLAG = {
  STRIPE_PAYMENTS: "stripePayments",
  LIVE_DICTATION: "liveDictation",
} as const;

export type FeatureFlag = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

export type FeatureFlags = Partial<Record<FeatureFlag, boolean>>;
